import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { forkJoin, of } from 'rxjs';

import { ContentData, SettingData, SignoutService } from '@app/core';
import { FormsModule } from '@angular/forms';
import { FsFormModule } from '@firestitch/form';
import { LogoComponent } from '../../../../libs/logo/components/logo/logo.component';
import { NgIf } from '@angular/common';
import { FsLabelModule } from '@firestitch/label';
import { FsHtmlRendererModule } from '@firestitch/html-editor';
import { FsCheckboxGroupModule } from '@firestitch/checkboxgroup';
import { MatCheckbox } from '@angular/material/checkbox';
import { StackedButtonsComponent } from '../../../../libs/stacked-buttons/components/stacked-buttons/stacked-buttons.component';
import { MatButton } from '@angular/material/button';
import { FsDateModule } from '@firestitch/date';


@Component({
    selector: 'app-terms-display',
    templateUrl: './terms-display.component.html',
    styleUrls: ['./terms-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FormsModule,
        FsFormModule,
        LogoComponent,
        NgIf,
        FsLabelModule,
        FsHtmlRendererModule,
        FsCheckboxGroupModule,
        MatCheckbox,
        StackedButtonsComponent,
        MatButton,
        FsDateModule,
    ],
})
export class TermsDisplayComponent implements OnInit {

  @Input() public contentWidgetTag: string;
  @Input() public effectiveDateSetting: string;
  @Input() public termsLabel: string;
  @Input() public agreeLabel: string;
  @Input() public header: string;
  @Input() public message: string;

  @Output() public submitted = new EventEmitter();

  public agreement;
  public effectiveDate: Date;
  public content: string;

  constructor(
    private _signoutService: SignoutService,
    private _contentData: ContentData,
    private _settingData: SettingData,
    private _cdRef: ChangeDetectorRef,
    private _router: Router,
    private _route: ActivatedRoute,
  ) { }

  public ngOnInit(): void {
    forkJoin({
      contentWidget: this._contentData.get(this.contentWidgetTag),
      effectiveDate: this._settingData.get(this.effectiveDateSetting),
    })
      .subscribe(({ effectiveDate, contentWidget }) => {
        this.content = contentWidget?.content;
        this.effectiveDate = effectiveDate;
        this._cdRef.markForCheck();
      });
  }

  public cancel(): void {
    this._signoutService.destroy()
      .subscribe(() => {
        this._router.navigate(['../../'], { relativeTo: this._route });
      });
  }

  public submit = () => {
    this.submitted.emit();

    return of(true);
  };

}
